import { useRef, useEffect, ForwardedRef } from 'react';

export function useCombineRef<T>(
  ...refs: (ForwardedRef<unknown> | undefined | null)[]
) {
  const targetRef = useRef<T>(null);

  useEffect(() => {
    refs.forEach((ref) => {
      if (!ref) {
        return;
      }

      if (typeof ref === 'function') {
        ref(targetRef.current);
      } else {
        ref.current = targetRef.current;
      }
    });
  }, [refs]);

  return targetRef;
}

export default useCombineRef;
